import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import TabPanel from './TabPanel';
import Carousel from '../carousel';
import { getTransformPropValue, getPxStyle } from './util/index';
import { scrollTo } from '../utils/dom';

var getSelectIndex = function getSelectIndex(children) {
  var selectIndex;
  React.Children.forEach(children, function (item, index) {
    if (item.props && item.props.selected) {
      selectIndex = index;
    }
  });
  return selectIndex;
};

var Tabs = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);
    _this.carousel = void 0;
    _this.layout = void 0;

    _this.setTablistRef = function (ref) {
      _this.layout = ref;
    };

    _this.setCarouselRef = function (ref) {
      _this.carousel = ref;
    };

    _this.onTabChange = function (value) {
      var onChange = _this.props.onChange;

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      typeof onChange === 'function' && onChange(value);
    };

    _this.onTabClick = function (tab, index) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          swipeable = _this$props.swipeable;

      if (disabled || tab.props.disabled) {
        return;
      }

      if (swipeable) {
        _this.carousel && _this.carousel.onSlideTo(index);
        return;
      }

      _this.onTabChange(index);
    };

    _this.renderTabs = function (tab, index) {
      var _classnames;

      if (!tab) {
        return;
      }

      var _this$props2 = _this.props,
          prefixCls = _this$props2.prefixCls,
          disabled = _this$props2.disabled;
      var value = _this.state.value;
      var itemCls = classnames("".concat(prefixCls, "__tab"), tab.props.className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "__tab--disabled"), disabled || tab.props.disabled), _defineProperty(_classnames, "".concat(prefixCls, "__tab--active"), value === index), _classnames));
      return /*#__PURE__*/React.createElement("li", {
        role: "tab",
        key: +index,
        className: itemCls,
        onClick: function onClick() {
          return _this.onTabClick(tab, index);
        }
      }, tab.props.title);
    };

    _this.caclLineSizePos = function () {
      var itemWidth = _this.state.itemWidth;
      var value = _this.currentValue;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          scrollable = _this$props3.scrollable;
      var ChildCount = React.Children.count(children);

      if (Array.isArray(children)) {
        ChildCount = children.filter(function (i) {
          return i;
        }).length;
      }

      var pos = 100 * value;

      if (scrollable && _this.layout) {
        var el = _this.layout.children[value];
        var _ref = el,
            _ref$offsetLeft = _ref.offsetLeft,
            offsetLeft = _ref$offsetLeft === void 0 ? 0 : _ref$offsetLeft,
            _ref$offsetTop = _ref.offsetTop,
            offsetTop = _ref$offsetTop === void 0 ? 0 : _ref$offsetTop;
        pos = _this.isVertical ? offsetTop : offsetLeft;
      }

      var size = scrollable ? "".concat(itemWidth, "px") : "".concat(100 / ChildCount, "%");
      var transformValue = scrollable ? getPxStyle(pos, 'px', _this.isVertical) : getPxStyle(pos, '%', _this.isVertical);
      var styleUl = getTransformPropValue(transformValue);
      var itemSize = _this.isVertical ? {
        height: "".concat(size)
      } : {
        width: "".concat(size)
      };
      return _objectSpread(_objectSpread({}, styleUl), itemSize);
    };

    _this.calculateScorllLeftLocation = function () {
      var scrollable = _this.props.scrollable;

      if (!scrollable) {
        return false;
      }

      var value = _this.currentValue;
      var index = value - 1 >= 0 ? value - 1 : 0;
      var prevTabItem = _this.layout.childNodes[index];

      if (scrollable && _this.layout && prevTabItem) {
        var _ref2 = prevTabItem,
            _ref2$offsetTop = _ref2.offsetTop,
            top = _ref2$offsetTop === void 0 ? 0 : _ref2$offsetTop,
            _ref2$offsetLeft = _ref2.offsetLeft,
            left = _ref2$offsetLeft === void 0 ? 0 : _ref2$offsetLeft;
        scrollTo(_this.layout, top, left, 0.3);
      }
    };

    _this.calculateLineWidth = function () {
      var scrollable = _this.props.scrollable;

      if (!scrollable) {
        return;
      }

      var value = _this.currentValue;
      var el = _this.layout.children[value];
      var size = _this.isVertical ? _this.getComputedStyle(el, 'height') : _this.getComputedStyle(el, 'width');

      _this.setState({
        itemWidth: parseInt(size, 10)
      });
    };

    _this.getComputedStyle = function (el, prop) {
      var value = '0';

      if (prop in el.style) {
        value = el.style[prop] || getComputedStyle(el).getPropertyValue(prop) || '0';
      }

      return value;
    };

    _this.state = {
      value: props.value || props.defaultValue || getSelectIndex(props.children) || 0,
      itemWidth: 0
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var children = this.props.children;

      if (React.Children.count(children)) {
        this.calculateLineWidth();
        this.calculateScorllLeftLocation();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevstate) {
      var prevValue = prevstate.value,
          prevChild = prevstate.children;
      var value = this.state.value;
      var children = this.props.children;

      if (prevValue !== value || prevChild !== children) {
        this.calculateLineWidth();
      }

      this.calculateScorllLeftLocation();
    }
  }, {
    key: "isVertical",
    get: function get() {
      var direction = this.props.direction;
      return direction === 'vertical';
    }
  }, {
    key: "currentValue",
    get: function get() {
      var value = this.state.value;
      var children = this.props.children;
      var count = React.Children.count(children);

      if (value < 0) {
        return 0;
      }

      if (value > count - 1) {
        return count - 1;
      }

      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          className = _this$props4.className,
          lineWidth = _this$props4.lineWidth,
          swipeable = _this$props4.swipeable,
          children = _this$props4.children,
          disabled = _this$props4.disabled,
          scrollable = _this$props4.scrollable,
          direction = _this$props4.direction;
      var value = this.currentValue;
      var classes = classnames(prefixCls, className, "".concat(prefixCls, "--").concat(direction), _defineProperty({}, "".concat(prefixCls, "--scroll"), scrollable)); // 渲染选项

      var _children = children;

      if (Array.isArray(_children)) {
        _children = _children.filter(function (i) {
          return i;
        });
      }

      var tabsRender = React.Children.map(_children, this.renderTabs); // 渲染内容

      var contentRender;

      if (swipeable) {
        contentRender = /*#__PURE__*/React.createElement(Carousel, {
          swipeable: !disabled,
          direction: direction === 'vertical' ? 'up' : 'left',
          showPagination: false,
          activeIndex: value,
          ref: this.setCarouselRef,
          onChange: function onChange(v) {
            _this2.onTabChange(v);
          }
        }, React.Children.map(children, function (item, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: +index
          }, item.props.children);
        }));
      } else {
        contentRender = React.Children.map(_children, function (item, index) {
          return item && item.props.children && /*#__PURE__*/React.createElement(TabPanel, _extends({}, item.props, {
            selected: value === index
          }));
        });
      }

      var lineStyle = this.caclLineSizePos();
      var lineInnerRender;

      if (lineWidth) {
        lineStyle.backgroundColor = 'transparent';
        lineInnerRender = /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "__line__inner"),
          style: {
            width: lineWidth
          }
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__header")
      }, /*#__PURE__*/React.createElement("ul", {
        className: "".concat(prefixCls, "__tablist"),
        role: "tablist",
        ref: this.setTablistRef
      }, tabsRender, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__line"),
        style: lineStyle
      }, lineInnerRender))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__body")
      }, contentRender));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ('value' in nextProps && nextProps.value !== state.prevValue) {
        return {
          value: nextProps.value,
          prevValue: nextProps.value
        };
      }

      return null;
    }
  }]);

  return Tabs;
}(PureComponent);

Tabs.Panel = void 0;
Tabs.defaultProps = {
  prefixCls: 'za-tabs',
  disabled: false,
  swipeable: false,
  scrollable: false,
  direction: 'horizontal'
};
export { Tabs as default };